const DisplayEventDateTime = (startDate: Date, endDate: Date | null) => {
  const sameYear = startDate.getFullYear() === endDate?.getFullYear();
  const sameMonth = startDate.getMonth() === endDate?.getMonth();
  const sameDay = startDate.getDate() === endDate?.getDate();

  return (
    <>
      {!sameDay &&
        startDate.toLocaleDateString('da-DK', {
          year: sameYear ? undefined : 'numeric',
          month: sameMonth ? undefined : 'long',
          day: sameDay ? undefined : 'numeric',
        })}
      {!sameDay &&
        endDate &&
        ` - ${endDate.toLocaleDateString('da-DK', {
          year: sameYear ? undefined : 'numeric',
          month: sameMonth ? undefined : 'long',
          day: sameDay ? undefined : 'numeric',
        })}`}
      {sameDay && ` ${endDate.toLocaleDateString('da-DK', { day: 'numeric' })}`}
      {sameMonth &&
        ` ${endDate.toLocaleDateString('da-DK', { month: 'long' })}`}
      {sameYear &&
        ` · ${endDate.toLocaleDateString('da-DK', { year: 'numeric' })}`}
    </>
  );
};

export default DisplayEventDateTime;
